"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BetDeExFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var BetDeExFactory = /** @class */ (function (_super) {
    __extends(BetDeExFactory, _super);
    function BetDeExFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    BetDeExFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    BetDeExFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    BetDeExFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    BetDeExFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    BetDeExFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return BetDeExFactory;
}(contracts_1.ContractFactory));
exports.BetDeExFactory = BetDeExFactory;
var _abi = [
    {
        inputs: [],
        stateMutability: 'nonpayable',
        type: 'constructor',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: '_ender',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: '_contractAddress',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint8',
                name: '_result',
                type: 'uint8',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: '_platformFee',
                type: 'uint256',
            },
        ],
        name: 'EndBetContract',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: '_deployer',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'address',
                name: '_contractAddress',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'uint8',
                name: '_category',
                type: 'uint8',
            },
            {
                indexed: true,
                internalType: 'uint8',
                name: '_subCategory',
                type: 'uint8',
            },
            {
                indexed: false,
                internalType: 'string',
                name: '_description',
                type: 'string',
            },
        ],
        name: 'NewBetEvent',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: '_betAddress',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: '_bettorAddress',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'uint8',
                name: '_choice',
                type: 'uint8',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: '_betTokensInExaEs',
                type: 'uint256',
            },
        ],
        name: 'NewBetting',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'previousOwner',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'newOwner',
                type: 'address',
            },
        ],
        name: 'OwnershipTransferred',
        type: 'event',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        name: 'clonedContracts',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'string',
                name: '_description',
                type: 'string',
            },
            {
                internalType: 'uint8',
                name: '_category',
                type: 'uint8',
            },
            {
                internalType: 'uint8',
                name: '_subCategory',
                type: 'uint8',
            },
            {
                internalType: 'uint256',
                name: '_minimumBetInExaEs',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: '_prizePercentPerThousand',
                type: 'uint256',
            },
            {
                internalType: 'bool',
                name: '_isDrawPossible',
                type: 'bool',
            },
            {
                internalType: 'uint256',
                name: '_pauseTimestamp',
                type: 'uint256',
            },
        ],
        name: 'createBet',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'dayswappers',
        outputs: [
            {
                internalType: 'contract IDayswappers',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_ender',
                type: 'address',
            },
            {
                internalType: 'uint8',
                name: '_result',
                type: 'uint8',
            },
            {
                internalType: 'uint256',
                name: '_gasFee',
                type: 'uint256',
            },
        ],
        name: 'emitEndBetEvent',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_bettorAddress',
                type: 'address',
            },
            {
                internalType: 'uint8',
                name: '_choice',
                type: 'uint8',
            },
            {
                internalType: 'uint256',
                name: '_betTokensInExaEs',
                type: 'uint256',
            },
        ],
        name: 'emitNewBettingEvent',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'getNumberOfBets',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'implementation',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        name: 'isBetValid',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'kycDapp',
        outputs: [
            {
                internalType: 'contract IKycDapp',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'nrtManager',
        outputs: [
            {
                internalType: 'contract INRTManager',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'owner',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_bettor',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: '_treeAmount',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: '_introducerAmount',
                type: 'uint256',
            },
        ],
        name: 'payRewards',
        outputs: [],
        stateMutability: 'payable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'prepaidEs',
        outputs: [
            {
                internalType: 'contract IPrepaidEs',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'randomnessManager',
        outputs: [
            {
                internalType: 'contract RandomnessManager',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: '_username',
                type: 'bytes32',
            },
        ],
        name: 'resolveAddress',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bytes32',
                name: '_username',
                type: 'bytes32',
            },
        ],
        name: 'resolveAddressStrict',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_wallet',
                type: 'address',
            },
        ],
        name: 'resolveUsername',
        outputs: [
            {
                internalType: 'bytes32',
                name: '',
                type: 'bytes32',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_wallet',
                type: 'address',
            },
        ],
        name: 'resolveUsernameStrict',
        outputs: [
            {
                internalType: 'bytes32',
                name: '',
                type: 'bytes32',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_kycDapp',
                type: 'address',
            },
        ],
        name: 'setKycDapp',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '_implementation',
                type: 'address',
            },
        ],
        name: 'storageFactory',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'timeallyClub',
        outputs: [
            {
                internalType: 'contract ITimeAllyClub',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'timeallyManager',
        outputs: [
            {
                internalType: 'contract ITimeAllyManager',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'timeallyPromotionalBucket',
        outputs: [
            {
                internalType: 'contract ITimeAllyPromotionalBucket',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'newOwner',
                type: 'address',
            },
        ],
        name: 'transferOwnership',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'validatorManager',
        outputs: [
            {
                internalType: 'contract IValidatorManager',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
];
var _bytecode = '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';
//# sourceMappingURL=BetDeExFactory.js.map